<template>
  <section class="modules-wrap">
    <!-- table start -->
    <el-table
      :data="tableData"
      height="100%"
      :border="true"
      :header-cell-style="{ color: '#333333', background: '#EFF6FF' }"
    >
      <el-table-column type="index" align="center" width="100" label="序号">
      </el-table-column>
      <el-table-column
        prop="time"
        align="center"
        min-width="150"
        show-overflow-tooltip
        label="时间段"
      ></el-table-column>
      <el-table-column
        prop="logistics_name"
        min-width="150"
        show-overflow-tooltip
        align="center"
        label="城市仓"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.logistics_name || "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="number"
        align="center"
        label="销售件数"
      ></el-table-column>
      <el-table-column prop="as_number" align="center" label="总售后数量">
      </el-table-column>
      <el-table-column
        prop="aftersale_proportion"
        align="center"
        label="售后率"
      ></el-table-column>

      <!-- <el-table-column
        label="操作"
        min-width="150"
        align="center"
        fixed="right"
      >
        <template slot-scope="scope">
          <el-button type="text" @click="onHandleEditData(scope.row)"
            >编辑</el-button
          >
          <el-button type="text" @click="onHandleDetail(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column> -->
    </el-table>
    <!-- table end -->
  </section>
</template>

<script>
export default {
  name: "TableList",
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {
    /**
     * 编辑
     */
    onHandleEditData(row) {},
    /**
     * 详情
     */
    onHandleDetail(row) {
      const query = {
        id: row.id,
      };
      this.$router.push({
        path: "/data-detail",
        query,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.modules-wrap {
  flex: 1;
  overflow: hidden;
  .table {
    height: calc(100% - 20px);
  }
}
</style>
